type Props = {
	title: string;
	dateFrom: string;
	dateTo: string;
	height: string;
};
const Card = (props: Props) => {
	return (
		<div className={"flex"}>
			<div className={"flex flex-col text-sm md:text-lg pr-1 md:px-2"}>
				<p className={"text-white whitespace-nowrap"}>{props.dateFrom}</p>
				<p className={"text-white whitespace-nowrap"}>〜{props.dateTo}</p>
			</div>
			<div
				className={`bg-white opacity-70 m-auto p-2 ${props.height} w-full text-center flex flex-col justify-center`}
			>
				<p>{props.title}</p>
			</div>
		</div>
	);
};
export const TimeSchedule = (props: {
	schedules: Props[];
	date: string;
}) => {
	return (
		<div
			className={
				"flex flex-col bg-black opacity-60 max-w-full w-[40rem] p-2 md:p-4"
			}
		>
			<p className={"text-center text-white my-4"}>{props.date}</p>
			<div className={"grid grid-cols-1 gap-2"}>
				{props.schedules.map((s, i) => (
					<Card key={s.title} {...s} />
				))}
			</div>
		</div>
	);
};
